import cx from 'classnames';
import Image from 'next/image';
import NextLink from 'next/link';

import {Button, Text} from '#component/base';
import {sprinkles} from '#style/sprinkles';

import * as css from './GetStarted.css';

export const GetStarted = ({className, ...otherProps}: React.ComponentPropsWithoutRef<'div'>) => (
  <div className={cx(css.root, className)} {...otherProps}>
    <div className={css.image}>
      <Image
        alt="A TallyAge™ kit."
        layout="fill"
        objectFit="cover"
        src="/image/gettingStartedCardHero.png"
      />
    </div>

    <div
      className={sprinkles({
        bg: 'cotton',
        dir: 'col',
        flex: 'flex',
        gap: [24, 32, 48],
        p: [24, 40, 64],
      })}>
      <Text as="h3" color="burgundy" variant="heading2">
        Take your first
        <br />
        epigenetic age test
      </Text>

      <Text as="p" color="doveGray" variant="bodyLarge">
        Get your TallyAge™ — a snapshot of how your body is aging on a cellular level and get
        personalized tips to improve your health.
      </Text>

      <div className={sprinkles({display: 'flex', flexDirection: ['col', 'row'], gap: 8})}>
        <NextLink href="/register" passHref>
          <Button
            as="a"
            className={sprinkles({w: ['auto', 'maxContent']})}
            icon="ArrowRight"
            variant="primary">
            Register your test
          </Button>
        </NextLink>

        <NextLink href="/profile?tab=manage" passHref>
          <Button
            as="a"
            className={sprinkles({w: ['auto', 'maxContent']})}
            icon="ArrowRight"
            variant="secondary">
            Order now
          </Button>
        </NextLink>
      </div>
    </div>
  </div>
);
